// src/components/modal/PolicyModal.js

import React from 'react';
import { Link, Typography } from '@mui/material';
import { useCustomTheme } from '../../contexts/ThemeContext';
import CustomModal from '../universal/modals/CustomModal';
import { PrivacyPolicyContent } from '../../helpers/PrivacyPolicy';

interface PolicyModalProps {
    closeModal: (resetForm?: () => void) => void; // Updated to match the definition
    isModalOpen: boolean;
    isMobile: boolean;
}

const PolicyModal: React.FC<PolicyModalProps> = ({
    isMobile,
    closeModal,
    isModalOpen,
}) => {
    const { theme } = useCustomTheme();
    return (
        <CustomModal
            isOpen={isModalOpen}
            onClose={() => closeModal()}
            isMobile={isMobile}
            cancelLabel={'Close'}
        >
            <PrivacyPolicyContent />
        </CustomModal>
    );
};

export default PolicyModal;
